import { render, staticRenderFns } from "./daily-task-update.vue?vue&type=template&id=c532e67e"
import script from "./daily-task-update.vue?vue&type=script&lang=js"
export * from "./daily-task-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports